import { Reveal } from "./Reveal";
import { AuditLink, BookCallButton } from "./Ctas";

export const CtaBand = ({ title = "Ready to Turn More Clicks Into Customers?", text = "Let's discover where your business could be performing better.", children }) => (
  <section className="grain relative overflow-hidden bg-[#2E1065] py-24 text-white sm:py-32" data-testid="final-cta">
    <div className="pointer-events-none absolute -left-32 top-0 h-[420px] w-[420px] rounded-full bg-[#7C3AED]/40 blur-[120px]" />
    <div className="pointer-events-none absolute -right-20 bottom-0 h-[320px] w-[320px] rounded-full bg-[#2563EB]/30 blur-[120px]" />
    <div className="relative mx-auto max-w-5xl px-5 text-center sm:px-8">
      <Reveal>
        <h2 className="text-4xl font-extrabold leading-[1.03] sm:text-5xl lg:text-6xl">{title}</h2>
        <div className="mx-auto mt-6 max-w-xl text-base text-violet-100 md:text-lg">{text}</div>
        <div className="mt-10 flex flex-wrap justify-center gap-3">
          {children || (
            <>
              <BookCallButton className="btn-ghost-dark" testid="final-cta-book-call" />
              <AuditLink label="Get a Free Digital Audit" testid="final-cta-audit" className="btn-accent" />
            </>
          )}
        </div>
      </Reveal>
    </div>
  </section>
);
